import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TruckFormService} from '../../services/truck-form/truck-form.service';
import {FormValidationService} from '../../services/form-validation/form-validation.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-assumptions',
  templateUrl: './assumptions.component.html',
  styleUrls: ['./assumptions.component.scss']
})
export class AssumptionsComponent implements OnInit {

  assumptionsForm: FormGroup;

  constructor(private formBuilder: FormBuilder, private truckFormService: TruckFormService,
              private formValidationService: FormValidationService, private router: Router) {
    this.assumptionsForm = this.loadAssumptionsForm();
  }

  ngOnInit(): void {
  }

  loadAssumptionsForm(): FormGroup {
    return this.truckFormService.assumptionsForm === null ?
      this.assumptionsForm = this.formBuilder.group({
        inflation: [9, [Validators.required, Validators.pattern('([0-9]+([.][0-9]*)?|[.][0-9]+)')]],
        discountRate: [8, [Validators.required, Validators.pattern('([0-9]+([.][0-9]*)?|[.][0-9]+)')]],
        hUpgradeRate: [1, [Validators.required, Validators.pattern('([0-9]+([.][0-9]*)?|[.][0-9]+)')]],
        dLifespan: [15, [Validators.required, Validators.pattern('([0-9]+([.][0-9]*)?|[.][0-9]+)')]],
        eLifespan: [15, [Validators.required, Validators.pattern('([0-9]+([.][0-9]*)?|[.][0-9]+)')]],
        hLifespan: [12, [Validators.required, Validators.pattern('([0-9]+([.][0-9]*)?|[.][0-9]+)')]],
        investment: [true],
        majorInvestment: [{value: 123000, disabled: true}, [Validators.required, Validators.pattern('([0-9]+([.][0-9]*)?|[.][0-9]+)')]],
        hInfrastructureCost: [2.62, [Validators.required, Validators.pattern('([0-9]+([.][0-9]*)?|[.][0-9]+)')]]
      }) : this.assumptionsForm = this.truckFormService.assumptionsForm;
  }

  submitForm(): void {
    this.truckFormService.saveAssumptionsForm(this.assumptionsForm);
    this.truckFormService.calculateTCO();
    this.router.navigateByUrl('/resultados');
  }

  getErrorMessage(fieldName: string): string {
    return this.formValidationService.getErrorMessage(this.assumptionsForm, fieldName);
  }

  changeInvestment(): void {
    if (!this.assumptionsForm.get('investment')?.value) {
      this.assumptionsForm.get('majorInvestment')?.enable();
      return;
    }

    this.assumptionsForm.get('majorInvestment')?.disable();
    // if (!this.assumptionsForm.get('investment')?.value) {
    //
    //   return;
    // }
    //
    // this.assumptionsForm.removeControl('majorInvestment');
  }

}
